const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  permissions: state => state.user.permissions,
  logo: state => state.user.logo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js